var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('landing-navbar'),_c('section',{staticClass:"container-fluid"},[_c('menu-grid',{attrs:{"isFromLanding":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }